import React from 'react';

import { FCC } from '@zazume/zzm-base';
import { BooleanHelper } from '@zazume/zzm-utils';

import { usePermissions } from '../../hooks';

interface ZazumeCanProps {
  if?: boolean;
}

export const ZazumeCan: FCC<ZazumeCanProps> = props => {
  const { includesRoles } = usePermissions();

  if (BooleanHelper.isFalse(props.if)) {
    return null;
  }

  if (!includesRoles(['zazume'])) {
    return null;
  }

  return <>{props.children}</>;
};
